// extracted by mini-css-extract-plugin
module.exports = {"OrganizationItemAvatar":"SOwZR8_mKNqwfNLKIxng","InivationStatus":"wPQoyrcmqcl6ukF6AJ5R","OrgRow":"GyBDCZzmMFrOcNpN0Km_","UserInfo":"KzLa_8J98n5hyQeJDJZq"};